import { jsxs as d, jsx as e } from "react/jsx-runtime";
import { z as g, d as h, J as x } from "../../vendor-CPVnY93G.js";
import { IconButton as m } from "../IconButton/index.js";
import { c as i } from "../../styles.module-BF2N4g8-.js";
import { useTableContext as u } from "./tableContext.js";
function M({ pageIndex: o, pageSize: s, totalCount: r }) {
  const c = x(), t = Math.max(0, Math.trunc(o)), n = Math.max(1, Math.trunc(s)), a = Math.max(0, Math.trunc(r)), b = a === 0 ? 0 : Math.max(0, Math.ceil(a / n) - 1), l = Math.min(t, b), f = a === 0 ? 0 : l * n + 1, p = Math.min(a, (l + 1) * n);
  return /* @__PURE__ */ e("span", { className: i.paginationRange, "aria-live": "polite", children: `${f}-${p} of ${c.format(a)}` });
}
function v({
  hasPreviousPage: o,
  hasNextPage: s,
  onPrevious: r,
  onNext: c,
  range: t,
  ...n
}) {
  const { isLoading: a } = u();
  return /* @__PURE__ */ d("nav", { className: i.pagination, "aria-label": n["aria-label"], children: [
    t ? /* @__PURE__ */ e(M, { ...t }) : null,
    /* @__PURE__ */ d(g, { className: h(i.paginationContent, a && i.paginationLoading), children: [
      /* @__PURE__ */ e(
        m,
        {
          size: "sm",
          variant: "ghost",
          icon: "chevron-back",
          onPress: () => {
            a || r();
          },
          "aria-disabled": a || void 0,
          isDisabled: !o,
          "aria-label": "Previous page"
        }
      ),
      /* @__PURE__ */ e(
        m,
        {
          size: "sm",
          variant: "ghost",
          icon: "chevron-next",
          onPress: () => {
            a || c();
          },
          "aria-disabled": a || void 0,
          isDisabled: !s,
          "aria-label": "Next page"
        }
      )
    ] })
  ] });
}
v.displayName = "Table.Pagination";
export {
  v as Pagination
};
